import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../lib/api";
import ExportCsvButton from "../components/ExportCsvButton";

const STATUS = { success: "badge-success", failed: "badge-failed", pending: "badge-pending", refunded: "badge-cooling" };

export default function PremiumLedger() {
  const { t } = useTranslation();
  const [data, setData] = useState({ items: [], summary: [] });

  useEffect(() => { api.get("/admin/premium-ledger").then((r) => setData(r.data)); }, []);

  return (
    <div className="p-8 space-y-6" data-testid="ledger-page">
      <header className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#c15337]">{t("admin_pages.ledger_section")}</div>
          <h1 className="font-heading text-3xl font-bold mt-1 text-[#114232]">{t("admin_pages.ledger_title")}</h1>
        </div>
        <ExportCsvButton path="/admin/exports/premiums.csv" filename="premiums" testid="export-premiums-csv" />
      </header>

      <section className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {(data.summary || []).map((s) => (
          <div key={s.status} className="metric-card" data-testid={`summary-${s.status}`}>
            <div className="text-xs uppercase tracking-[0.18em] text-stone-500 font-semibold">{s.status}</div>
            <div className="mt-3 text-2xl font-bold font-mono tracking-tight">
              KES {s.total.toLocaleString()}
            </div>
            <div className="text-xs text-muted-foreground mt-1">{s.count} {t("admin_pages.ledger_transactions")}</div>
          </div>
        ))}
      </section>

      <div className="bg-white border border-border rounded-md overflow-x-auto">
        <table className="w-full text-sm" data-testid="ledger-table">
          <thead className="text-xs uppercase tracking-wider text-stone-500">
            <tr>
              <th className="text-left font-medium py-3 px-5">Date</th>
              <th className="text-left font-medium py-3 px-5">Reference</th>
              <th className="text-left font-medium py-3 px-5">Provider</th>
              <th className="text-left font-medium py-3 px-5">Policy</th>
              <th className="text-left font-medium py-3 px-5">Amount</th>
              <th className="text-left font-medium py-3 px-5">Status</th>
            </tr>
          </thead>
          <tbody>
            {(data.items || []).map((p) => (
              <tr key={p.id} className="border-t border-border table-row-hover" data-testid={`ledger-row-${p.id}`}>
                <td className="py-3 px-5 text-xs text-muted-foreground">
                  {new Date(p.created_at).toLocaleString()}
                </td>
                <td className="py-3 px-5 font-mono text-xs">{p.reference}</td>
                <td className="py-3 px-5 capitalize">{p.provider}</td>
                <td className="py-3 px-5 font-mono text-xs">{p.policy_id.slice(0, 8)}…</td>
                <td className="py-3 px-5 font-mono">KES {p.amount.toLocaleString()}</td>
                <td className="py-3 px-5">
                  <span className={`badge-status ${STATUS[p.status] || "badge-pending"}`}>{p.status}</span>
                </td>
              </tr>
            ))}
            {(!data.items || data.items.length === 0) && (
              <tr><td colSpan={6} className="py-10 text-center text-muted-foreground">No transactions</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
